import './switch.style.sass';
import template from './switch.tpl.pug';

class SwitchController {
    change() {
        this.$ctrl.$setViewValue(this.toggled);
        this.$ctrl.$render();
    }
}

export default {
    selector: 'dbASwitch',
    template: template(),
    controller: SwitchController,
    transclude: true,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        toggled: '<ngModel',
        disabled: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/switch/switch.cmpt.js